import React, { Component } from "react";

class About extends Component{
    render(){
        let title = 'About Us',
        description = 'Zeodel Technologies Private Limited is a software company that builds modern digital solutions for businesses. We combine technical expertise with a clear understanding of your goals to deliver web applications, mobile apps, and custom software that scale with you.';
        return(
            <React.Fragment>
                <div className="about-wrapper">
                    <div className="container">
                        <div className="row row--35 align-items-center">

                            <div className="col-lg-5 col-md-12">
                                <div className="thumbnail">
                                    <img className="w-100" src="/assets/images/about/software-office.jpg" alt="About Zeodel Technologies Private Limited"/>
                                </div>
                            </div>

                            <div className="col-lg-7 col-md-12">
                                <div className="about-inner inner">
                                    <div className="section-title">
                                        <h2 className="title">{title}</h2>
                                        <p className="description">{description}</p>
                                    </div>
                                    <div className="row mt--30 mt_sm--10">
                                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div className="about-us-list">
                                                <h3 className="title">Who we are</h3>
                                                <p>We are a team of engineers and designers focused on building reliable, user-friendly software that helps businesses grow and operate more efficiently.</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div className="about-us-list">
                                                <h3 className="title">What we do</h3>
                                                <p>From web and mobile development to strategy and reporting, we deliver end-to-end solutions tailored to your industry and requirements.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default About;